// Compare two arrays element wise.
;(window.HB = window.HB || {}).arrayLessThan = function (arr1, arr2) {
  if (!Array.isArray(arr1) || !Array.isArray(arr2)) {
    return false
  }

  const len = Math.min(arr1.length, arr2.length)

  for (let i = 0; i < len; i++) {
    if (arr1[i] !== arr2[i]) {
      return arr1[i] < arr2[i]
    }
  }

  return arr1.length < arr2.length
}
